/**
 * 委托书模块的韩文文案。键与 design-sheet.zh-CN.ts 必须一一对应。
 */
export default {
  sheetInfo: {
    requestType: "의뢰 유형",
    requestNo: "의뢰서 번호",
    requestDate: "의뢰일",
    chargePlan: "상품기획",
    chargeProduction: "생산 담당",
    chargeFabric: "원부자재 구매",
    chargeTrim: "부자재 구매",
    chargePattern: "패턴 담당",
    chargeCad: "패턴 담당",
    batch: "생산 배치",
    batchHint: "생산 배치: 같은 스타일은 최초가 00이고, 추가 발주마다 1씩 증가합니다",
  },

  stageProgress: '자료 진행',
  nextStep: '다음 작업 / 담당',
  next: {
  cancelled: '취소됨',
  fixAndResubmit: '반려 의견 반영 수정 · 디자이너',
  awaitApproval: '승인 대기 · 디자인 실장',
  awaitTechpack: 'Tech Pack 검토 대기 · 생산관리',
  rolesFinishing: '담당별 자료 보완 중 · 다수 역할',
  startDesign: '작성 시작 · 디자이너',
  designing: '디자인 작성 중 · 디자이너',
  },
  sheetSection: {
    "DESIGN": "디자인",
    "MATERIAL": "원부자재",
    "PATTERN": "패턴 지정",
    "QUANTITY": "발주 수량",
    "TECHPACK": "Tech Pack",
    "QC": "QC의뢰서",
    "ONLINE": "온라인 상품 정보",
    "USP": "USP·디자인 의도"
  },

  sheetSectionState: {
    "done": "완료",
    "partial": "진행 중",
    "todo": "작성 전",
    "planned": "예정",
    "readonly": "읽기 전용"
  },

  sheetStage: {
    "TRIM_TECHNICAL_DONE": "부자재 기술자료 완료",
    "STEP_DONE": "단계 완료",
    "DESIGNER_DONE": "디자이너 작성 완료",
    "PURCHASE_DONE": "원부자재 구매 완료",
    "PRODUCTION_REVIEWED": "생산 검토 완료",
    "USAGE_ENTERED": "요척 입력 완료",
    "BASE_SIZE_DONE": "기준사이즈 입력 완료",
    "SIZE_SPEC_DONE": "사이즈스펙 입력 완료",
    "QUANTITY_CONFIRMED": "수량 확인 완료"
  },


  chargeRole: {
    "DESIGN": "디자인",
    "PLAN": "기획",
    "FABRIC": "원부자재 구매",
    "TRIM": "부자재",
    "PRODUCTION": "생산",
    "PATTERN": "패턴",
    "CAD": "패턴사",
    "TECHPACK": "텍펙"
  },

  country: {
    "KR": "한국",
    "CN": "중국",
    "HK": "홍콩",
    "TW": "대만",
    "MY": "말레이시아"
  },

  techpack: {
    noSketch: "도식화가 아직 등록되지 않았습니다",
    fabrication: "소재정보 Fabrication",
    colorway: "칼라 배색군, 워싱 Color Way, Washing",
    orderQuantity: "오더 수량 Order Quantity",
    total: "합계 Total",
    sizeSpec: "사이즈 스펙 SIZE SPEC(CM)",
    patternPart: "패턴부위 Description",
    designMemo: "디자인 메모 Design Memo",
    styleCode: "스타일 코드",
    colorCode: "컬러코드",
    sizeCode: "사이즈코드",
    skuCode: "단품코드-차수",
    all: "전체",
    colorNm: "컬러명",
    sizeNm: "사이즈명",
    qty: "수량",
    moduleModelCd: "모듈 모델번호",
    moduleStyleCd: "모듈 스타일번호"
  },

  sheetTab: {
    "deviation": "치수 편차",
    "images": "이미지 자료",
    "main": "款式 정보",
    "fabric": "소재·칼라웨이",
    "trimBom": "부자재 BOM",
    "cost": "원가 및 소요량",
    "size": "패턴·사이즈",
    "quantity": "발주 수량",
    "techpack": "검토·Tech Pack",
    "qc": "QC의뢰서",
    "online": "온라인 상품 정보",
    "usp": "USP·디자인 의도"
  },

  sheetStatus: {
    DRAFT: '임시저장',
    PENDING: '승인 대기',
    APPROVED: '승인 완료',
    REJECTED: '반려',
    CANCELLED: '폐기',
  },



  sheet: {
    removeRowConfirm: '이 행과 상세자료를 삭제할까요?',
    sectionUnavailable: '현재 제공되지 않는 항목입니다.',
  todoMissingPrice: '단가 미입력',
  todoMissingUsage: '소모량 미입력',
  todoTechpackDone: 'Tech Pack 확인 완료',
  todoNotTransferred: 'SAP 미전송',
    allColors: "전색 공통",
    pickColors: "적용 컬러 선택",
    materialAlias: "별칭 Article",
    materialAliasPlaceholder: "과거 소재 별칭",
    moduleModelCd: "모듈 모델번호",
    moduleStyleCd: "모듈 스타일번호",
    patternModuleNo: "패턴 모듈 번호",
    patternModuleNoPlaceholder: "예: EEYW",
    realYardage: "실소요량",
    tolMinus: "−허용값",
    tolPlus: "+허용값",
    vendorNmPlaceholder: "Tech Pack 각 페이지 헤더에 표시",
    lCategory: "대분류",
    mCategory: "중분류",
    sCategory: "소분류",
    vendorNm: "공급처",
    composition: "혼용률",
    compositionPlaceholder: "예: C 100%",
    finishing: "가공",
    stepTag: "{n}단계",
    materialsStepNote: "폭은 7단계, 요척은 10단계 담당이 입력합니다. Tech Pack 소재 표에 출력되는 항목이라 이 화면에서 바로 입력할 수 있게 열어 두었습니다.",
    stdSizesNoSizes: "컬러와 사이즈 정보를 아직 받지 못했습니다. 상품기획 담당자에게 이전 단계의 전송 자료를 확인해 주세요.",
    bomGroup: "구분",
    bomGroupTrim: "부자재",
    bomGroupThread: "재봉사",
    trimImage: "부자재 이미지",
    trimImageAfterSave: "저장 후 업로드",
    orderQuantity: "오더 수량",
    orderQuantityHint: "이전 단계에서 확정된 발주 수량을 컬러와 사이즈별로 조회합니다. 다시 확인할 필요가 없습니다.",
    orderQuantityEmpty: "이 스타일의 발주 수량을 아직 받지 못했습니다. 상품기획 담당자에게 전송 자료를 확인해 주세요.",
    quantityReadonly: "수량 스냅샷 · 읽기 전용",
    readonlyFromSap: "SAP 연동 · 읽기 전용",
    techPackTitle: "Tech Pack 미리보기",
    techPackHint: "기술 자료를 검토하세요. PDF 내보내기를 누른 후 인쇄 창에서 PDF로 저장을 선택하세요.",
    exportPdf: "PDF 내보내기",
    shippingHint: "Shipping Instruction의 4개 구역, Tech Pack 7페이지에 해당합니다.",
    inProgressSuffix: " 중",
    techPackPreview: "TECH PACK 미리보기",
    techPackTodo: "TECH PACK 미리보기는 준비 중입니다",
    flatSketch: "도식화",
    designDraft: "디자인원",
    designDraftHint: "의뢰서의 핵심 디자인 이미지입니다. PDF 업로드 시 이미지로 자동 분리되며, 여러 장의 이미지도 올릴 수 있습니다.",
    flatSketchHint: "의뢰서의 핵심 도면입니다. 업로드 후 클릭하면 원본을 볼 수 있습니다.",
    fgImage: "FG 자료",
    fgImageHint: "FG 자료는 이미지, PDF, Illustrator(.ai) 원본을 지원합니다.",
    fgTypeError: "FG 자료는 이미지, PDF, Illustrator(.ai) 원본을 지원합니다.",
    uploadFg: "FG 자료 업로드",
    uploadHub: {
      tooLarge: "'{name}' 파일이 {mb}MB 제한을 초과했습니다",
    },
    detailImages: "상세이미지",
    detailImagesHint: "디테일·공정 참고 이미지, 여러 장 업로드 가능",
    trimImages: "부자재 관련 이미지",
    trimImagesHint: "부자재 이미지, 라벨 봉제 방법, Shipping 정보",
    subMaterialImage: "부자재 이미지",
    labelSewing: "라벨 봉제 방법",
    shipping: "Shipping 정보",
    patternSpecImage: "패턴스펙이미지",
    patternSpecImageHint: "패턴 규격 설명 이미지",
    subMaterials: "부자재 BOM",
    subMaterialsHint: "부자재 행 + 사이즈별 규격 + 색상별 색상명. 우측 「+」로 하위 항목을 펼칩니다.",
    subMaterialsEmpty: "부자재가 없습니다 — [행 추가]로 시작하세요",
    subMaterialType: "부자재 종류",
    subMaterialCd: "부자재 코드",
    subMaterialContents: "부자재 내용",
    subMaterialUsedPart: "사용부위",
    subMaterialSizes: "사이즈별 규격",
    subMaterialColors: "색상별 색상명",
    sizeCd: "사이즈",
    gauge: "규격",
    gaugeUnit: "규격 단위",
    unitPrice: "단가",
    currency: "통화",
    colorNm: "색상명",
    detail: "상세",
    stdSizes: "기준치수",
    stdSizesHint: "샘플 기준 설명. 한 행이 한 패턴부위입니다.",
    stdSizesEmpty: "기준치수가 없습니다 — [마스터에서 가져오기] 또는 [행 추가]로 시작하세요",
    stdSizesLaterNote: "좌우 편차와 허용치는 「치수 편차」 단계에서 입력하며 여기서는 비워둘 수 있습니다.",
    baseSizeIs: "기준 사이즈 {size}",
    fillFromMaster: "마스터에서 가져오기",
    fillDialogTitle: '마스터에서 부위 가져오기',
    fillDialogHint: '총 1,030개 부위, 사용 빈도 순 정렬. 코드/명칭으로 검색 후 선택(한 번에 최대 100행).',
    fillSearchPlaceholder: '코드 / 명칭 검색',
    fillSelectAll: '현재 필터 모두 선택',
    fillClearAll: '선택 해제',
    fillSelectedCount: '선택 {n} / 최대 {max}',
    fillAdded: '{n}행 추가됨',
    patternPart: "패턴부위",
    patternPartNm: "부위명",
    sizeValue: "치수",
    tolLeft: "좌 편차",
    tolRight: "우 편차",
    measurement: "측정 방법",
    attachAdd: "파일 업로드",
    attachReplaceImage: "이미지 교체",
    attachImageTypeError: "JPG, PNG, WEBP 또는 GIF 이미지를 선택하세요.",
    attachImagesHint: "PNG / JPG / WEBP / GIF · ≤{mb} MB",
    attachReplace: "파일 교체",
    attachUploading: "업로드 중…",
    attachUploaded: "업로드되었습니다",
    attachLoadFailed: '파일을 불러오지 못했습니다',
    attachEmpty: "파일이 없습니다",
    attachHint: "PNG / JPG / WEBP / GIF / PDF, 개당 20MB 이하",
    sourceAttachHint: "PDF / PPT, 개당 {mb}MB 이하",
    sourceTypeError: "디자인 원본은 PDF와 PPT 파일만 받습니다",
    attachOpen: "클릭하여 열기",
    designSource: "디자인 원본",
    designSourceHint: "디자이너가 올린 PDF / PPT 원본 전체입니다. 양식 인식과 이력 추적용이며 Tech Pack에는 들어가지 않습니다. 「디자인 원고 가져오기」 시 자동으로 저장됩니다.",
    attachTypeError: "지원하지 않는 파일 형식입니다. 이미지와 PDF만 가능합니다",
    attachSizeError: "파일이 {mb}MB 제한을 초과했습니다",
    attachDeleteConfirm: "이 첨부파일을 삭제하시겠습니까?",
    changeLog: "수정이력",
    changeLogCount: "{n}건",
    changeLogThisSection: "현재 단계",
    changeLogAll: "전체",
    changeLogEmpty: "이 단계에서 수정한 이력이 아직 없습니다.",
    changeLogTime: "일시",
    changeLogActor: "수정자",
    changeLogArea: "영역",
    changeLogFields: "수정한 항목",
    changeLogSheetLevel: "의뢰서 전체",
    sectionNotImplemented: "아직 개발되지 않은 단계입니다",
    sectionNotImplementedDesc: "현재 제공되지 않는 항목입니다.",
    listDesc: '의뢰서는 5~13단계가 공유하는 문서입니다. 생성 후 상세 화면에서 단계별로 정보를 채웁니다.',
    create: '의뢰서 생성',
    createdWith: '의뢰서 {modelCd} 이(가) 생성되었습니다',
    deleteConfirm: '의뢰서 {modelCd} 을(를) 삭제하시겠습니까? 되돌릴 수 없습니다.',
    deleted: '삭제되었습니다',
    saved: '저장되었습니다',
    searchPlaceholder: '의뢰서 코드 / 스타일 코드 / 품명 검색',

    modelCd: '의뢰서 코드',
    styleCd: '스타일 코드',
    styleNm: '품명',
    version: '차수',
    versionNo: '{n}차',
    status: '상태',
    statusLabel: '상태',
    currentStep: '현재 단계',
    brand: '브랜드',
    item: '생산 품목',
    apparelType: '완제품 유형',
    gender: '성별',
    productYear: '년도',
    season: '시즌',
    salesMonth: '판매월',
    yearSeason: '년도·시즌',
    yearSeasonMonth: '년도·시즌·판매월',
    category: '카테고리',
    salePrice: '판매가',
    tagPrice: '택 가격',
    receivingDueDate: '입고 요청일',
    designer: '디자이너',
    sketchShort: '도식화',
    sketchLoadFailed: '도식화를 불러오지 못했습니다',
    owners: '담당',
    progress: '진행률',
    stageCount: '단계 {done}/{total}',
    stepCount: '단계 {done}/{total}',

    pickStyle: '스타일 코드 선택',
    pickStylePlaceholder: '스타일 코드 또는 품명 검색',
    pickStyleHint:
      '스타일 코드는 SAP에서 생성됩니다. 선택하면 브랜드·년시즌·품목·담당·색상·사이즈가 자동으로 반영됩니다.',
    pickStyleEmpty: '먼저 스타일 코드를 선택하세요',
    existingCount: '{n}건 존재',
    existingWarn: '이 스타일 코드에 이미 {n}건의 의뢰서가 있습니다',
    createNote: '생성 시 스타일의 색상 목록으로 칼라웨이 행이, 디자인 메모와 소재 1행이 함께 생성됩니다.',
    provisionalModelCd: '임시 코드',
    provisionalModelCdHint:
      '스타일 마스터에 중분류(MCategoryCD)가 없어 의뢰서 코드의 해당 두 자리를 -- 로 채웠습니다. 중분류는 SP0120 으로 SAP에서 푸시되며, 연동 후 이 의뢰서는 코드를 다시 채번해야 합니다.',
    provisionalModelCdWarn:
      '이 스타일 코드에는 중분류(MCategoryCD)가 없어 의뢰서 코드가 XX--G24001 같은 임시 코드로 생성됩니다. 이후 단계 진행에는 문제가 없지만 SP0120 연동 후 재채번이 필요합니다.',
    pickFromList: '목록에서 선택',
    pickFair: '수주회에서 가져오기',
    fairBrand: '브랜드',
    fairEvent: '수주회',
    fairHint: '브랜드를 고른 뒤 수주회를 선택하면 해당 수주회에서 수주량이 있는 모든 스타일이 표시됩니다.',
    fairSearchPlaceholder: '스타일번호로 검색',
    fairCount: '{n} / 전체 {total} 스타일 표시',
    fairQty: '수주량',
    fairPick: '이 스타일로 생성',
    fairImported: '{styleCd} 을(를) 로컬 마스터에 가져왔습니다',
    fairImportOk: '「{event}」에서 해당 스타일을 가져왔습니다',
    fairImportCounts: '컬러 {colors}개 · 사이즈 {sizes}개 · 수량 {quantities}행 · 합계 {qty}장',
    fairQtyNote:
      '주의: 여기의 수량은 수주회의 대리점 수주량 합계이며 SAP의 기획수량이 아닙니다. 가격도 예판가가 아니라 택 가격입니다.',
    fairGeneratedAt: '수주 시스템 실시간 조회 결과이며 생성 시각은 {at} 입니다',
    fairMissing:
      '다음 항목은 수주회에서 제공하지 않아 비어 있습니다: {fields}. 담당자와 입고 요청일은 SAP 스타일 마스터에 있으므로, 해당 스타일이 SAP에 등록되어 있다면 「스타일 코드 직접 입력」으로 한 번 더 가져와 채울 수 있습니다.',
    charges: '담당자',
    pickManual: '스타일 코드 직접 입력',
    manualStyleCd: '스타일 코드 · 차수',
    manualStyleCdPlaceholder: '전체 스타일 코드 입력 (예: EEYSH12E01)',
    styleCdSeqPlaceholder: '00',
    manualStyleHint:
      'SAP에는 전체 스타일 코드 목록 인터페이스가 없습니다. 로컬에 없는 신규 코드는 여기에 직접 입력하면 SP0110 을 즉시 호출해 가져옵니다. 차수 기본값은 00 입니다. 한 번 호출에 30초 이상 걸리므로 클릭 후 기다려 주세요. 중복 클릭은 하지 마세요.',
    manualStyleEmpty: '스타일 코드를 입력한 뒤 [SAP에서 가져오기] 를 누르세요',
    fetchFromSap: 'SAP에서 가져오기',
    fetching: '가져오는 중',
    fetchingHint: 'SAP에서 가져오는 중입니다. 동기 호출은 보통 30초 이상 걸리니 창을 닫지 마세요.',
    syncOk: '{styleCd} 을(를) 가져왔습니다 ({sec}초 소요)',
    syncCreated: 'SAP에서 가져와 스타일 마스터를 신규 생성했습니다',
    syncUpdated: 'SAP에서 가져와 스타일 마스터를 갱신했습니다',
    syncCounts: '색상 {colors}개 · 사이즈 {sizes}개 · 오더수량 {quantities}행',
    syncNewTagColors: '이 중 {n}개 색상은 로컬 코드에 없어 SAP 색상명으로 추가했습니다.',
    syncMissing:
      '다음 항목은 SP0110 이 제공하지 않아 비어 있습니다: {fields}. SP0120 으로 SAP에서 푸시되는 항목이며 아직 수신 엔드포인트가 없습니다.',
    colors: '색상',
    sizes: '사이즈',
    baseSize: '기준',

    basicInfo: '메인정보',
    basicInfoHint: 'SAP 스타일 정보(초록 점)는 생성 시 자동으로 가져온 것으로 여기서 수정할 수 없습니다',
    editableFields: '본 시스템 입력',
    stdSize: '기준 사이즈',
    stdSizePlaceholder: '예: 160',
    stitchDensity: '스티치 밀도',
    stitchDensityPlaceholder: '예: 14침/인치',
    remark: '비고',

    materials: '소재정보',
    materialsHint: '원단. 사용부위·원단분류·원단코드는 필수',
    materialsEmpty: '원단이 없습니다 — [행 추가]로 시작하세요',
    materialsLaterNote: '폭과 소요량은 [소요량 입력] 후 입력합니다.',
    usedPart: '사용부위',
    materialGroup: '원단분류',
    materialCode: '원단코드',
    materialNm: '원단명',
    materialMemo: '원단메모',
    fabricMemo: '원단 비고',
    removeColorColumn: '열 줄이기',
    removeColorColumnConfirm: '{part} 열과 배색 내용을 제거할까요?',
    colorColumnInUse: '원단에서 {part} 배색 부위를 사용 중입니다. 원단 자료를 먼저 수정해 주세요.',
    addColorColumn: '열 추가',
    usageAndCost: '소요량 및 원가',
    usageAndCostHint: '디자이너가 등록한 원단·부자재 목록입니다. 소요량은 필수이며, 단가와 통화는 소재 구매 담당자가 입력할 수 있습니다.',
    usageAndCostEmpty: '원단과 부자재가 없습니다 — [원단·배색] 또는 [부자재 BOM]에서 먼저 등록하세요',
    usageAndCostSaved: '소요량과 단가를 저장했습니다',
    usageMissing: '{n}건의 소요량이 아직 입력되지 않았습니다',
    kind: '종류',
    size: '사이즈',
    amount: '금액',
    totalCost: '합계',
    restSizes: '그 외 사이즈',
    fabric: '원단',
    trim: '부자재',
    fillYardage: '소요량 입력',
    exitYardage: '기본 정보로',
    widthRequired: '폭은 필수',
    yardageRequired: '소요량은 필수',
    colorMatchPart: '배색부위',
    tagColor: 'Tag 색상',
    width: '폭',
    yardage: '소요량',
    unit: '단위',
    searchMaterial: '소재 마스터 검색',
    detailFields: '상세 필드(별칭 / 공급사 / 혼용률 / 가공 등)',
    weight: '중량',
    searchMaterialPlaceholder: '소재코드 또는 이름 입력',

    colorway: '칼라웨이',
    colorwayHint: '한 행이 한 Tag 색상, A~G는 일곱 배색부위',
    colorwayUsed: '{n}개 사용',
    colorwayEmpty: '칼라웨이 행이 없습니다',
    washingInfo: 'Washing',
    used: '사용',

    designMemo: '디자인 메모',
    designMemoHint: '고정 6행, 한글·영문 각 1열',
    memoKo: '한글',
    memoEn: '영문',

    qcTitle: 'QC의뢰서',
    qcHint: '회차별 검사 자료를 기록합니다.',
    qcEmpty: 'QC 기록이 없습니다 — 「QC 차수 추가」로 시작하세요',
    qcAddRound: 'QC 차수 추가',
    qcRoundName: '{n}차 QC',
    qcStateDraft: '작성 중',
    qcStateDone: '완료',
    qcRemoveRound: '이 차수 삭제',
    qcRemoveConfirm: '{n}차 QC를 삭제하시겠습니까? 해당 차수의 실측 기록과 코멘트도 함께 삭제되며 복구할 수 없습니다.',
    qcConfirm: '차수완료 [{n}차]',
    qcUnconfirm: '완료 취소',
    qcLockedHint: '완료된 차수는 수정할 수 없습니다. 수정하려면 완료를 먼저 취소하세요',
    qcBaseInfo: '{n}차 QC — 기준정보',
    qcBaseSize: '실측 기준 사이즈',
    qcType: 'QC 유형',
    qcDictNote: 'QC 유형과 RESULT의 코드값은 인터페이스 정의서에 없어 백엔드 팀 확인 후 마스터에 등록합니다. 드롭다운이 비어 있어도 다른 항목 입력에는 영향이 없습니다.',
    qcAttachments: 'QC 첨부파일',
    qcAttachmentsHint: '공장 회신 자료 및 샘플 사진.',
    qcSizeCheck: '사이즈 스펙 체크',
    qcSizeCheckHint: 'STANDARD SPEC은 패턴기준스펙에서 복사한 스냅샷입니다. DIFF = 실측 − 기준, 자동 계산',
    qcSizeCheckEmpty: '실측 항목이 없습니다 — 「패턴기준스펙으로 새로고침」 또는 「행 추가」로 시작하세요',
    qcRefreshStd: '패턴기준스펙으로 새로고침',
    qcComments: 'QC 코멘트 — 공장 · 본사',
    qcCommentsHint: '이번 버전은 본사에서 대신 입력하며, 공장 측 의견도 여기에 기록합니다',
    qcCommentsEmpty: '등록된 코멘트가 없습니다',
    qcAddCommentFactory: '공장 코멘트 추가',
    qcAddCommentHq: '본사 코멘트 추가',
    qcSideFactory: '공장',
    qcSideHq: '본사',
    qcCommentAuthorPh: '기록자',

    onlineSizeSpec: 'SIZE SPEC 실측',
    onlineSizeSpecHint: '상세페이지에 노출되는 사이즈 표입니다. 보통 핵심 부위 4~6개만 넣으며 패턴기준스펙 전체가 아닙니다',
    onlineSizeSpecEmpty: '실측 항목이 없습니다 — 「패턴기준스펙으로 채우기」 또는 「행 추가」로 시작하세요',
    onlineFillFromStdSize: '패턴기준스펙으로 채우기',
    onlineItemCd: '코드',
    onlineItemNm: '실측 항목명',
    onlineItemNmEn: '영문 (생의서)',
    onlineCustomerLabel: '고객 표기',
    onlineMeasureMethod: '측정 방법',
    onlineProductInfo: 'PRODUCT INFO 상품 정보',
    onlineProductInfoHint: '온라인 판매용입니다. 선택지는 코드 마스터에서 옵니다',
    onlineWash: '세탁방법',
    onlineFit: '핏',
    onlineElastic: '신축성',
    onlineThickness: '두께감',
    onlineLining: '안감',
    onlineSheer: '비침',
    onlineMemo: '선택 메모',
    onlineMemoPh: '상품정보 보충 설명',
    onlineDictEmpty: '해당 코드 마스터가 비어 있습니다. 마스터 초기화를 먼저 실행하세요',

    uspPoints: '핵심 셀링포인트',
    uspPointsHint: '상세페이지·내부 검토용, 기본 3건이며 추가·삭제 가능',
    uspPointTitlePh: '셀링포인트',
    uspPointDescPh: '설명',
    uspIntent: '디자인 의도 · 타깃',
    uspIntentHint: 'SAP로 전송되지 않는 본 시스템 자체 기록입니다',
    uspDesignIntent: '디자인 의도',
    uspDesignIntentPh: '실루엣, 디테일, 소재 선택의 이유',
    uspTargetCustomer: '타깃 고객',
    uspTargetCustomerPh: '핵심 고객과 착용 상황',
    uspSilhouette: '실루엣',
    uspSilhouettePh: '예: 세미 오버핏',
    uspStylingTip: '스타일링 팁',
    uspStylingTipPh: '코디 제안',
    uspSellingCopy: '상세페이지 셀링 카피',
    uspSellingCopyPh: '고객용 한 줄 카피',

    seq: '순번',
  emptyTitle: '의뢰서가 없습니다',
  emptyDesc: '오더페어 또는 기존 스타일로 첫 의뢰서를 시작하세요.',
  copiedFrom: '{style}에서 복사',
  copiedFromHint: '이 의뢰서의 내용은 {model}에서 프리필했습니다(원단·치수 등 수정 가능)',
  addRow: '행 추가',
  batchEntry: {
    open: '일괄 입력',
    title: '부자재 일괄 입력(단가/소모량)',
    hint: '총 {total}개의 「부자재 × 사이즈」 중 {missing}개가 미입력입니다. 입력 후 창을 닫고 카드에서 저장하면 반영됩니다.',
    onlyMissing: '미입력만 보기',
    ph: '입력',
    foot: '입력값은 카드에 바로 반영되며 저장 전까지 수정할 수 있습니다. 단가와 통화는 짝으로 입력하세요.',
  },
    removeRow: '행 삭제',

    submit: '승인 요청',
    submitted: '승인 요청되었습니다',
    submitPrompt:
      '요청하면 디자인 내용이 승인 절차에 들어가며 그동안 수정할 수 없습니다(다른 역할의 입력에는 영향 없음). 요청 사유를 입력할 수 있습니다:',
    submitCommentPlaceholder: '요청 사유(선택)',
    approve: '승인',
    approved: '승인되었습니다',
    approvePrompt: '이 디자인 내용을 승인할까요? 의견을 입력할 수 있습니다:',
    approveMemoPlaceholder: '승인 의견(선택)',
    reject: '반려',
    rejected: '반려되었습니다',
    rejectPrompt: '이 디자인 내용을 반려합니다. 무엇을 수정해야 하는지 적어 주세요:',
    rejectMemoPlaceholder: '반려 사유(필수)',
    rejectMemoRequired: '반려 시 사유는 필수입니다',
    rejectedBy: '{name} 님이 {at} 에 반려',
    issuesTitle: '미완료 항목이 {n}건 있어 승인 요청할 수 없습니다',
    readyToSubmit: '정보가 완전합니다. 승인 요청할 수 있습니다',
    history: '상태 변경 이력',
    pendingTitle: '{name} 님이 {at} 에 디자인 승인을 요청했습니다({n}번째 요청)',
    pendingTitleNoRound: '{name} 님이 {at} 에 디자인 승인을 요청했습니다',
    pendingComment: '요청 사유: {text}',
    pendingLastReject: '지난 반려 의견: {text}',
    pendingHintApprover: '디자인 내용을 확인한 뒤 오른쪽 위에서 「승인」 또는 「반려」하세요.',
    pendingHintDesigner:
      '디자인 승인 대기 중입니다. 디자인을 수정하려면 먼저 요청을 철회하세요.',
    pendingHintOther: '디자인 승인은 디자이너 담당 내용만 잠그며, 담당하신 입력에는 영향이 없습니다.',
    approvalHistory: '승인 이력 {n}',
    approvalRound: '{n}번째 요청',
    approvalSubmittedBy: '{name} 님이 {at} 에 요청',
    approvalDecidedBy: '{name} 님이 {at} 에 결정',
    approvalWithdrawn: '철회',
    approvalWithdrawnBy: '{name} 님이 {at} 에 철회',
    purchaseDoneUnpriced: '단가(또는 통화)가 없는 원단 {fabric}행, 부자재 {trim}행이 있어 원가가 낮게 계산됩니다. 그래도 「원부자재 구매 완료」로 표시할까요?',
    purchaseDoneAnyway: '그래도 표시',
    withdraw: '요청 철회',
    withdrawPrompt: '철회하면 의뢰서가 초안으로 돌아가며, 수정한 뒤 다시 승인 요청할 수 있습니다. 철회 사유를 입력할 수 있습니다:',
    withdrawReasonPlaceholder: '철회 사유(선택)',
    withdrawn: '철회했습니다. 의뢰서가 초안으로 돌아갔습니다',

  },

  pageImport: {
    open: '디자인 원고 가져오기',
    title: '디자인 원고 가져오기 (PDF / 이미지)',
    intro: 'PDF 전체 또는 여러 장의 이미지를 한 번에 넣으면 페이지별로 나눕니다. 1페이지는 도식화, 나머지는 상세 이미지로 기본 지정되며 페이지마다 위치와 순서를 바꿀 수 있습니다.',
    drop: '파일을 여기로 끌어오거나',
    pick: '파일 선택',
    addMore: '계속 추가',
    accept: 'PDF, PNG, JPG, WebP, GIF 지원, 이미지 한 장당 {mb} MB 이하. PowerPoint는 먼저 PDF로 저장한 뒤 넣어 주세요.',
    pptTitle: 'PowerPoint는 페이지로 나누지 않습니다. PDF로 저장해 주세요',
    pptHint: 'PowerPoint에서 「파일 → 다른 이름으로 저장 → PDF」로 저장한 뒤 PDF를 넣으면 페이지별로 나눕니다. 아래 PPT는 페이지로 나누지 않습니다(「디자인 원본으로 저장」을 선택했다면 보관만 됩니다): {names}',
    keepOriginals: 'PDF / PPT 원본도 「디자인 원본」으로 저장(나중에 양식 인식에 사용)',
    sourceTooLarge: '원본이 {mb} MB를 넘어 디자인 원본으로 저장하지 않습니다: {names}',
    uploadWithSources: '{n}페이지와 원본 {m}개 업로드',
    doneWithSources: '{n}페이지를 가져오고 원본 {m}개를 저장했습니다',
    unsupported: '지원하지 않는 파일 형식이라 건너뛰었습니다: {names}',
    tooLarge: '{mb} MB를 넘는 이미지라 건너뛰었습니다: {names}',
    renderFailed: '「{name}」을(를) 읽을 수 없습니다. 파일이 손상되었거나 암호가 걸려 있을 수 있습니다',
    rendering: '페이지 나누는 중 {done} / {total}',
    uploading: '업로드 중 {done} / {total}',
    page: '{n}페이지',
    targetSkip: '업로드 안 함',
    moveUp: '위로',
    moveDown: '아래로',
    remove: '제거',
    overfilled: '「{kind}」에는 한 장만 넣을 수 있는데 여러 페이지가 지정되어 있습니다',
    willReplace: '「{kind}」에 이미 이미지가 있어 가져오면 교체됩니다',
    empty: '아직 선택한 파일이 없습니다',
    upload: '{n}페이지 업로드',
    done: '{n}페이지를 가져왔습니다',
  },
  attachKind: {
    SHIP_TAGGING: "라벨 봉제",
    SHIP_BOXING: "박싱",
    SHIP_FOLDING: "접기 및 포장",
    SHIP_IRON: "다림질",

    FLAT_SKETCH: '도식화',
    DETAIL_IMAGE: '상세 이미지',
    FG_IMAGE: 'FG 자료',
    DESIGN_SOURCE: '디자인 원고',
    SUB_MATERIAL_IMAGE: '부자재 이미지',
    LABEL_SEWING: '라벨 재봉 방법',
    SHIPPING: 'Shipping 정보',
    SHIP_FRONT: '앞면 Shipping',
    SHIP_BACK: '뒷면 Shipping',
    SHIP_LEFT: '왼쪽 Shipping',
    SHIP_RIGHT: '오른쪽 Shipping',
    PATTERN_SPEC_IMAGE: '패턴 치수 도면',
    QC_ATTACHMENT: 'QC 첨부',
  },
  changelog: {
    attachmentUpload: '上传了「{kind}」：{file}',
    attachmentDelete: '删除了「{kind}」：{file}',
  },
  draftImport: {
    title: '인식된 디자인 정보',
    hint: '작업지시서의 텍스트 레이어에서 읽어 아래 대응 관계로 채웠습니다. 확인 후 필요하면 수정하고, 확정하면 의뢰서에 입력됩니다.',
    styleMismatch: '작업지시서의 스타일번호는 {draft}, 본 의뢰서는 {sheet} 입니다 —— 파일이 맞는지 확인해 주세요.',
    hStyleCd: '스타일번호',
    hSeason: '시즌',
    hCollection: '컬렉션',
    hItemName: '품명',
    hDesigner: '디자이너',
    hRequestDate: '의뢰일',
    pickSubMaterials: '부자재 BOM에 입력({n}행)',
    pickMaterials: '주자재에 입력({n}행)',
    pickColorways: 'ColorWay에 입력({n}행)',
    willReplace: '현재 {n}행이 있으며 전체 교체됩니다',
    done: '{n}행을 입력했습니다',
    noteUsedPartManual: '원단의 「부위」·「위치」는 작업지시서의 자유 입력 문자라 비고에 합쳤습니다 —— 사용부위는 코드값이므로 직접 선택해 주세요.',
    noteColorUnmatched: '컬러 표의 「{name}」이(가) 이 스타일의 컬러에 없어 이 행은 기록하지 않았습니다.',
    noteSizeUnparsed: '{no}번 부자재의 규격 「{text}」이(가) 「숫자 + 단위」 형식이 아니어서 비고에 넣었습니다.',
    noteQtyUnparsed: '{no}번 부자재의 수량 「{text}」이(가) 숫자가 아니어서 비고에 넣었습니다.',
    mergeColorways: '이 스타일의 기존 ColorWay 행에 병합: {filled}행 채움, 나머지 {kept}행 유지',
    logFrom: '《{file}》에서 인식 가져오기',
    logPart: { materials: '주자재 {n}행', colorways: 'ColorWay {n}행', subMaterials: '부자재 {n}행' },
  },

  // 01 디자인 · 디자인원 업로드 (2026-10-05). sheet.designDraft가 문자열이므로
  // 하위 객체를 둘 수 없어 최상위에 둔다.
  designDraftUpload: {
    replacePdf: "PDF 다시 업로드",
    replaceImages: "이미지 다시 업로드",

    uploadPdf: 'PDF 업로드',
    uploadImages: '이미지 여러 장 업로드',
    chooseKind: '이 {n}장의 이미지는 어떤 종류인가요?',
    kind: {
      sketch: '디자인 이미지',
      sketchHint: '스타일 디자인 이미지이며, 의뢰서의 핵심 디자인원입니다',
      detail: '스타일 참고 이미지',
      detailHint: '참고 이미지나 세부 이미지 등, 핵심 디자인원으로 사용하지 않습니다',
      fg: 'FG 이미지(원본)',
      fgHint: '완성 의류 실물 사진 원본입니다',
    },
  },

  prefill: {
    partsUnavailable: '현재 제공되지 않는 내용이 포함되어 있습니다. 새로고침한 뒤 다시 선택하세요.',
    open: '기존 의뢰서로 채우기',
    afterCreate: '생성 후 기존 의뢰서로 채우기',
    title: '기존 의뢰서로 채우기',
    intro: '기존 의뢰서(예: 같은 패턴의 스타일)를 골라 가져올 수 있는 내용을 한 번에 이 의뢰서에 채운 뒤 항목별로 수정합니다. 원본 의뢰서는 바뀌지 않습니다.',
    searchPlaceholder: '모델번호 / 스타일번호 / 품명 / 패턴 모듈 번호',
    sameBrand: '{brand} 브랜드만 보기',
    module: '패턴 {no}',
    noResult: '사용할 수 있는 의뢰서가 없습니다',
    from: '이 의뢰서에서 채우기',
    otherRolesNote: '소요량, 치수 등 다른 역할 담당 내용도 함께 가져옵니다. 채운 뒤 각 역할이 자기 부분을 확인해 주세요.',
    noPriceNote: '원단과 부자재 단가는 가져오지 않습니다. 단가는 부자재 구매 담당자가 입력하며, 원본 단가는 대개 이전 스타일 기준이라 그대로 옮기면 안 됩니다.',
    sizeMismatch: '두 스타일의 사이즈가 다릅니다(원본 {src}, 이 의뢰서 {dst}). 사이즈별 데이터는 양쪽에 모두 있는 사이즈만 가져옵니다.',
    colorMismatch: '원본에만 있는 컬러({list})의 데이터는 가져오지 않습니다.',
    sourceEmpty: '원본 비어 있음',
    willReplace: '이 의뢰서에 이미 {what}이(가) 있어 채우면 교체됩니다',
    countRows: '{n}행',
    countItems: '{n}항목',
    countImages: '{n}장',
    back: '다시 선택',
    submit: '{n}개 부분 채우기',
    done: '{src}에서 {n}개 부분을 채웠습니다',
    reportTitle: '채우기 완료',
    reportDroppedSizes: '이 스타일에 없는 사이즈는 가져오지 않았습니다: {list}',
    reportDroppedColors: '이 스타일에 없는 컬러는 가져오지 않았습니다: {list}',
    reportMissingFiles: '첨부 파일 {n}개를 읽을 수 없어 가져오지 않았습니다(다른 사람 PC에만 있을 수 있음)',
    reportSkipped: '원본에서 비어 있어 이 의뢰서를 바꾸지 않은 부분: {list}',
    logFrom: '{src}에서 채움:',
    part: {
      DESIGN_BASIC: '메인 정보',
      DESIGN_MEMO: '디자인 메모',
      DESIGN_IMAGES: '도식화 / 상세 이미지 / FG 이미지',
      MATERIALS: '주자재',
      COLORWAYS: 'ColorWay',
      SUB_MATERIALS: '부자재 BOM(부자재 이미지 포함)',
      MATERIAL_IMAGES: '라벨 봉제 / Shipping 이미지',
      STD_SIZES: '기준치수(패턴 스펙 이미지 포함)',
      ONLINE: '온라인 상품 정보',
      USP: 'USP·디자인 의도',
    },
  },

  cost: {
    title: '사전 원가',
    hint: '원단·부자재는 BOM의 소요량 × 단가로 실시간 계산하며, 여기서는 BOM에 없는 항목만 입력합니다. 단가·소요량을 저장하면 바로 반영됩니다. 기준은 초안이며 파라미터는 「환율·원가 파라미터」에서 확인하세요.',
    loadFailed: '원가 데이터를 불러오지 못했습니다. 잠시 후 새로고침하세요.',
    totalCost: '사전 원가',
    salePrice: '예상 소매가',
    costRatio: '사전 원가율',
    basisLabel: '소요량 기준',
    basis: {
      ESTIMATE: '예상 소요량',
      ACTUAL: '실제 소요량',
      MIXED: '예상 + 실제',
    },
    inputTitle: '원가 입력',
    purchaseMode: '구매 방식',
    modeUnset: '미선택(자사 공급으로 계산)',
    mode: {
      CMT: '자사 공급(CMT)',
      FOB: '공장 일괄(FOB)',
    },
    currency: '원가 통화',
    fobPrice: 'FOB 단가',
    processingCost: '가공비',
    processingInFob: 'FOB 단가에 가공비 포함',
    outsourcingCost: '외주 공정비',
    customsCost: '통관비',
    memo: '비고',
    inputNote: '금액은 모두 1장 기준, {cur}로 입력합니다.',
    breakdownTitle: '항목별(1장)',
    fabricCost: '원단',
    trimCost: '부자재',
    directCost: '직접비 합계',
    overheadCost: '간접비({rate})',
    referenceBomCost: '참고: BOM 원부자재 원가(합계 제외)',
    paramsLine: '파라미터: {scope} · 원단 로스 {loss} · 간접비 {overhead} · 세율 {vat} · 원가 한도 {limit}',
    scopeDefault: '전사 기본',
    noLimit: '미설정',
    warnLines: '단가 없는 행 {price}개, 소요량 없는 행 {consumption}개는 원가에 포함되지 않았습니다 — 현재 원가는 낮게 계산되어 있습니다.',
    warnLinesFob: '단가 없는 행 {price}개, 소요량 없는 행 {consumption}개로 참고 원가(BOM 원부자재)가 낮게 계산되어 있습니다. FOB 건의 합계에는 영향이 없습니다.',
    warnRates: '환율 없음: {rates}. 「환율·원가 파라미터」에서 입력하세요.',
    warnFob: 'FOB 건인데 FOB 단가가 입력되지 않았습니다.',
    warnSaleCurrency: '판매가에 통화가 없습니다(SAP 예정 판매가는 통화를 주지 않음). 원가율은 계산하지 않으며 통화 확인이 필요합니다.',
    warnSalePrice: '판매가가 없어 원가율을 계산하지 않습니다.',
    warnMode: '구매 방식이 선택되지 않아 자사 공급으로 계산합니다.',
    warnNoQuantity: '오더 수량이 아직 없습니다: 일부 컬러/사이즈에만 쓰이는 행은 컬러·사이즈 개수로 균등 배분합니다.',
    linesTitle: '행별 상세({n}행)',
    colKind: '구분',
    colItem: '코드 / 명칭',
    colSize: '사이즈',
    colConsumption: '소요량',
    colPrice: '단가',
    colLoss: '로스',
    colWeight: '비중',
    colAmount: '1장 금액({cur})',
    colProblem: '문제',
    noLines: '원단·부자재 행이 없습니다',
    lineKind: {
      FABRIC: '원단',
      TRIM: '부자재',
    },
    problem: {
      NO_CONSUMPTION: '소요량 없음',
      NO_PRICE: '단가 없음',
      NO_CURRENCY: '단가 통화 없음',
      NO_RATE: '환율 없음',
    },
    snapshotsTitle: '원가 스냅샷',
    noSnapshots: '아직 확정한 적이 없습니다. 확정한 스냅샷은 이후 수정에 영향받지 않으며 사후 원가와 비교하는 데 씁니다.',
    frozenAt: '확정 시각',
    frozenBy: '확정자',
    completeLabel: '데이터',
    complete: '완비',
    incomplete: '누락 있음',
    snapshotTitle: '원가 스냅샷 #{n}',
    snapParams: '원단 로스 {loss} · 간접비 {overhead} · 세율 {vat}',
    snapRates: '당시 환율: ',
    freeze: '스냅샷 확정',
    freezePrompt: '현재 원가를 스냅샷으로 확정합니다. 이후 단가·소요량을 바꿔도 영향받지 않습니다. 비고를 남길 수 있습니다:',
    freezeIncompletePrompt: '현재 원가에 누락이 있어(낮게 계산됨) 스냅샷에도 「누락 있음」으로 표시됩니다. 그래도 확정할까요? 비고를 남길 수 있습니다:',
    freezeMemoPlaceholder: '예: 1차 견적, 샘플 후 갱신',
    saveBeforeFreeze: '원가 입력이 저장되지 않았습니다. 저장 후 확정하세요.',
    frozen: '원가 스냅샷을 확정했습니다',
    logFreeze: '원가 스냅샷 #{n} 확정: {total} {cur}',
    openHint: '원가 상세 보기',
    incompleteHint: '단가·소요량·환율이 없는 행은 포함되지 않아 원가가 낮게 계산되어 있습니다',
  },
  costConfig: {
    desc: '의뢰서의 사전 원가는 여기의 파라미터와 환율로 계산합니다. 기준은 초안이며, 업무 회신 후 여기서 조정하면 되고 코드는 바꿀 필요가 없습니다.',
    paramsTitle: '원가 파라미터',
    paramsHint: '전사 기본 한 세트, 기준이 다른 브랜드는 별도 세트를 만들어 기본값을 통째로 대체합니다.',
    addBrand: '브랜드 파라미터 추가',
    scope: '적용 범위',
    fabricLossRate: '원단 로스율',
    overheadRate: '간접비 비율',
    vatRate: '원가율 세율',
    costLimitRatio: '원가 한도',
    builtinRemark: '내장 기본값(아직 저장 안 됨)',
    pctInvalid: '퍼센트 숫자로 입력하세요. 예: 5는 5%',
    scopeRequired: '브랜드 코드를 입력하세요',
    paramsDeleteConfirm: '브랜드 {scope}의 파라미터를 삭제할까요? 삭제 후에는 전사 기본으로 계산합니다.',
    ratesTitle: '환율',
    ratesHint: '앞 통화 1단위 = 뒤 통화 얼마. 한 방향만 입력하면 반대 방향은 역수로 계산하며, 특정 날짜에는 적용일이 그날 이전인 최신 환율을 씁니다.',
    rate: '환율',
    effectiveDate: '적용일',
    source: '출처',
    pair: '통화쌍',
    inUse: '오늘',
    current: '사용 중',
    future: '미적용',
    noRates: '환율이 없습니다. 단가 통화가 원가 통화와 다르면 환율이 없는 행은 원가에 포함되지 않습니다.',
    rateDeleteConfirm: '{pair}({date} 적용) 환율을 삭제할까요?',
    brandPlaceholder: '브랜드 코드, 예: EE',
    overrideNote: '원가 한도를 비워 두면 한도 없음(원가율 색 표시 안 함). 원가율이 한도를 넘으면 빨강, 한도의 90%에 이르면 노랑입니다.',
  },

  subMaterialLib: {
    emptyTitle: '부자재 라이브러리가 비어 있습니다',
    emptyDesc: '수동 생성하거나 SAP 이관을 기다리세요(过渡方案).'.replace('过渡方案','전환 방안'),
    desc: '전사 공용 부자재 마스터입니다. 과도기에는 두 출처가 함께 있습니다: 원단 구매가 SAP에 등록한 것(조회 후 한 벌 저장, 명칭·규격·단가는 SAP 기준)과 여기서 새로 만든 것(SAP에 동기화해 자재번호를 받아야 함).',
    create: '부자재 등록',
    createTitle: '부자재 등록',
    searchPlaceholder: '코드 / 명칭 / SAP 자재번호',
    type: '종류',
    brand: '브랜드',
    allBrands: '공용',
    statusLabel: '상태',
    sourceLabel: '출처',
    empty: '부자재 라이브러리에 아직 부자재가 없습니다',
    image: '이미지',
    code: '코드',
    name: '명칭',
    specAndPrice: '규격 · 단가',
    status: {
      ACTIVE: '사용',
      LOCKED: '잠금',
      INACTIVE: '중지',
    },
    source: {
      SAP: 'SAP 등록',
      LOCAL: '본 시스템 등록',
      IMPORT: '가져오기',
    },
    sync: {
      NOT_REQUIRED: 'SAP 기존',
      PENDING: 'SAP 등록 대기',
      SYNCED: 'SAP 등록 완료',
      FAILED: 'SAP 등록 실패',
    },
    provisional: '임시 코드',
    provisionalHint: 'SAP 부자재 코드 규칙이 아직 정해지지 않아 본 시스템이 먼저 발급한 임시 코드입니다. SAP 등록 후 정식 자재번호로 바꿉니다',
    nameRequired: '부자재 명칭을 입력하세요',
    deleteConfirm: '부자재 {code}을(를) 삭제할까요? 삭제 후에는 복구할 수 없습니다.',
    deleted: '삭제했습니다',
    imageType: '{name}은(는) 이미지가 아닙니다(PNG / JPG / WebP / GIF만 가능)',
    imageTooLarge: '{name}이(가) 20 MB를 넘습니다',
    usage: '의뢰서 {n}건에서 사용 중(그중 {approved}건 승인)',
    sapReadonly: 'SAP 등록 부자재: 명칭·종류·규격·단가는 SAP 기준이라 여기서 수정할 수 없습니다. 사용 설명과 이미지는 보완할 수 있습니다.',
    lockedHint: '잠금 상태: 규격과 단가를 바꿀 수 없습니다. 품질이 바뀌면 기존 것을 고치지 말고 새 코드를 만드세요 — 기존 의뢰서는 기존 품질을 참조합니다.',
    baseTitle: '기본 정보',
    codePlaceholder: '비워 두면 임시 코드(TMP-) 자동 발급',
    sapMaterialNo: 'SAP 자재번호',
    sapNoPlaceholder: '이미 SAP에 등록된 경우 입력',
    brandPlaceholder: '비워 두면 전 브랜드 공용',
    unit: '단위',
    vendor: '공급처',
    specsTitle: '규격과 단가',
    specsHint: '부자재 하나에 여러 건 가능(규격별 단가 상이). 의뢰서로 가져올 때는 첫 번째를 기본으로 사용',
    gauge: '규격',
    gaugeUnit: '규격 단위',
    unitPrice: '단가',
    currency: '통화',
    unitWeight: '개당 중량',
    weightUnit: '중량 단위',
    noSpecs: '규격이 없습니다',
    sapGroups: 'SAP 분류(BU / 대중소 분류, SAP 등록 건에 포함)',
    memo: '사용 설명',
    memoPlaceholder: '예: 뒷목 중심 아래 2cm에 봉제; 케어라벨과 메인라벨 동일 공급처',
    images: '이미지',
    imagesAfterSave: '먼저 저장한 뒤 이미지를 올리세요',
    addImage: '이미지 업로드',
    lock: '잠금',
    activate: '사용',
    deactivate: '중지',
    codeSearch: '코드나 명칭으로 부자재 라이브러리 검색',
    filled: '부자재 라이브러리에서 가져옴: {fields}(빈 칸만 채움)',
    fill: {
      type: '종류',
      contents: '명칭',
      unit: '단위',
      gauge: '규격',
      price: '단가',
    },
    bomInactive: '중지됨 · 다른 부자재를 선택해 주세요',
    bomNotInLib: '원부자재 구매 검토 대기',
    logCodeRenamed: '부자재 코드 {from} → {to}(부자재 라이브러리에서 SAP 자재번호 입력 시 자동 변경)',
    exportPending: 'SAP 등록 대기 목록 내보내기',
    backfill: 'SAP 자재번호 입력',
    backfillTitle: 'SAP 자재번호 입력',
    backfillHint: 'SAP 등록 결과를 붙여 넣으세요: 한 줄에 「본 시스템 코드」「SAP 자재번호」 두 열(Excel에서 두 열을 그대로 복사해도 됨). 임시 코드(TMP-)는 자재번호로 바뀌고, 이를 참조하는 의뢰서 부자재 BOM도 함께 바뀌며 각 의뢰서의 수정 이력에 기록됩니다.',
    backfillPlaceholder: 'TMP-7K2Q9D\t318EE0301\nTMP-8M3R2F\t318EE0302',
    backfillParsed: '{n}쌍 인식',
    backfillBadLine: '두 열로 인식하지 못한 줄: {line}',
    backfillSubmit: '{n}건 입력',
    backfillResult: '입력 성공 {ok}건, 실패 {fail}건',
    backfillOutcome: '결과',
    backfillRenamed: '자재번호로 바꿨고, 의뢰서 {n}건의 부자재 코드도 함께 바꿨습니다',
    backfillOk: '자재번호를 기록했습니다',
    backfillOne: '입력',
    sapNoBackfillPlaceholder: 'SAP 등록 후 자재번호 입력',
    readinessBlocking: '부자재 {n}행의 정보가 미완료입니다. 해당 행을 확인해 주세요.',
    bomCodeRequired: '부자재 코드를 선택해 주세요',
    bomPending: '원부자재 구매 확인 대기',
    draftSummary: '부자재 라이브러리 대조: 있음 {ok}행, 중지 {inactive}행, 없음 {notInLib}행',
    draftFill: '부자재 라이브러리로 빈 칸 채우기',
    draftFilled: '부자재 라이브러리로 {n}행을 채웠습니다(빈 칸만)',
    draftLibColumn: '부자재 라이브러리',
    draftLib: {
      OK: '✓ 있음',
      INACTIVE: '✗ 중지',
      NOT_IN_LIB: '⚠ 없음',
      NO_CODE: '— 코드 미인식',
      CHECKING: '조회 중…',
    },
  },
};
